<template>
  <div
    v-if="!$template.landing_disabled_campaign_title"
    class="title campaign-title !mt-1 lg:!mt-4 text-normal !mb-0 !p-4"
    v-html="tagText($template.landing_campaign_title)"
  ></div>
  <div v-if="$template">
    <HeaderEntry :isLanding="true" />

    <div class="w-[80%] lg:w-full mt-4 pb-6 flex justify-center text-base lg:text-xl mx-auto">
      <button @click="gGoToEntry()" class="button-validation lg:!p-3" v-html="tagText($template.landing_campaign_button)">
      </button>
    </div>
  </div>
</template>

<script>
import HeaderEntry from '../common/components/HeaderEntry.vue'
import Bandit from '../common/components/Bandit.vue'
import InputText from '../common/components/Inputs/InputText.vue'
import InputSelect from '../common/components/Inputs/InputSelect.vue'
import { ErrorMessage, Field, Form } from 'vee-validate'
import moment from 'moment'

export default {
  name: 'EntryAView',
  components: {
    HeaderEntry,
    Bandit,
    InputText,
    InputSelect,
    ErrorMessage,
    Form,
    Field
  },
  emits: ['openModal', 'openNotification'],
  data: () => ({
    errors: [],
    form: {},
    towns : [],
    isGameFinish : false,
  }),
  computed: {
  },
  created() {
    if (this.$user && this.$template.mandatory_purchase) {
      this.$router.replace({ name: 'product' })
    }
  },
  methods: {
    openModal(title, message, img) {
      this.$emit('openModal', title, message, img)
    },
    async gGoToEntry() {
      //!recall
      if (this.$user) {
        if (this.$template.mandatory_purchase) {
          if (this.$template.is_entry) {
            this.$router.replace({
              name: 'acquisition-purchase',
              params: { campaignCode: this.$campaign.code }
            })
          } else {
            this.$router.replace({ name: 'product' })
          }
        } else {
          this.$router.replace({
            name: 'acquisition',
            params: { campaignCode: this.$campaign.code }
          })
        }
        
      } else {
        this.$router.replace({
          name: 'acquisition',
          params: { campaignCode: this.$campaign.code }
        })

      }
    }
  }
}
</script>

<style scoped>
.campaign-title {
  background-color: v-bind(
    "$template ? $template.landing_campaign_title_background_color : ''"
  );
}

.button-validation {
  background-color: v-bind(
    "$template ? $template.landing_campaign_button_background_color : ''"
  );
  color: v-bind("$template ? $template.landing_campaign_button_text_color : ''");
}

.campaign-container {
  background-color: v-bind(
    "$template && !$template.landing_disabled_campaign_text ? $template.landing_campaign_text_background_color : ''"
  );
}

.campaign-container {
  @apply p-8;
}

.div-form {
  @apply lg:flex  w-full mt-3;
}

.input-form {
  @apply lg:w-1/2 lg:mr-4 mt-3 lg:mt-0;
}
</style>
